import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { AfterViewInit, Component, OnInit, ViewChild, ChangeDetectorRef, Input } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { MatTableDataSource } from '@angular/material/table';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, of, Subscription } from 'rxjs';
import { debounceTime, filter, map, startWith } from 'rxjs/operators';
import { GlobalComponents } from './../global-constants';
import { TablaItem } from "./tabla-datasource";
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { SpeakerCountry } from 'src/app/models/speakerModel/speaker-country';
import { userResponse } from '../../../models/userModel/userResponse';
import { userListModel } from '../../../models/userModel/userListModel';
import { MeetingService } from './../../../core/services/meeting.service';
import { TranscriptionService } from './../../../core/services/transcription.service';
import { SpeakerService } from './../../../core/services/speaker.service';
import { UserService } from './../../../core/services/user.service';
import { ModalMeetingComponent } from './../modal-meeting/modal-meeting.component';
import { AudioService } from './../../../core/services/audio.service';
import { Language } from '../../../models/languageModel/language';
import * as fileSaver from 'file-saver';
import { DatePipe } from '@angular/common';
import { AccessControlService } from './../../../core/services/accessControl.service';
import { MeetingModel } from "src/app/models/meetingModel/MeetingModel";
import { AudioPlayerPortalService } from "src/app/core/portals/audio-player-portal/audio-player-portal.service";
import { environment } from "src/environments/environment";
import { AudioPlayerPortalComponent } from "src/app/core/portals/audio-player-portal/audio-player-portal.component";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  providers: [AudioPlayerPortalComponent]
})
export class HomeComponent implements AfterViewInit, OnInit {
  username: string;
  isDirectory = false;
  ver: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TablaItem>;
  dataSource: MatTableDataSource<TablaItem>;
  tableDataSource: TablaItem[];
  obs: Observable<any>;

  public users: userResponse[];
  public finding: boolean = true;
  public searchLoading: boolean = false;

  public SEC: boolean = false;
  public STB: boolean = false;
  public Directory: boolean = false;
  public NoShowSteering: boolean = false;
  public SteeringCommittees: string[] = ['Steering Committee','IDB Steering Committee']
  public PresidentCommittees: string[] = ["President's Committee"]

  private routeSubscription: Subscription;

  showAdvancedFilters = false;

  startDate = new FormControl();
  endDate = new FormControl();
  typeForm = new FormControl();
  oratorForm = new FormControl();
  agendaForm = new FormControl();
  countryForm = new FormControl();
  textForm = new FormControl();

  public parentForm: FormGroup;
  public options = new Array<string>();
  public filteredOptions: Observable<string[]>;
  public isLoadingInputData: boolean = true;

  public meetingList = new Array<MeetingModel>();
  public countryList = new Array<SpeakerCountry>();
  public filterMeetingOptions: Observable<MeetingModel[]>;
  public selectedCountry: string;
  public selectedMeeting: number;

  public usersList: userListModel[];
  public filterUserOptions: Observable<userListModel[]>;
  public filterCountryOptions: Observable<SpeakerCountry[]>;

  selectedUsers: string[] = [];
  filteredUsers: Observable<userListModel[]>;
  lastFilter: string = "";
  filters: any = [];

  lastMeeting: any;
  lastLang: string;


  constructor(private dialog: MatDialog,
              private changeDetectorRef: ChangeDetectorRef,
              private router: Router,
              private route: ActivatedRoute,
              private serviceMeeting: MeetingService,
              private serviceTranscription: TranscriptionService,
              private serviceSpeaker: SpeakerService,
              private serviceUsers: UserService,
              private serviceAudio: AudioService,
              public datepipe: DatePipe,
              private accessControlService: AccessControlService,
              private audioPlayerService: AudioPlayerPortalService,
              private audioAplayerPortal: AudioPlayerPortalComponent
              ) { }

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  directoryDisplayedColumns = [
    "idMeeting",
    "date",
    "directory",
    "diary",
    "speaker",
    "country",
    "audio",
  ];

  secDisplayedColumns = [
    "idMeeting",
    "date",
    "directory",
    "diary",
    "speaker",
    "country",
    "transcription",
    "audio",
    "download",
  ];
  
  stbDisplayedColumns = [
    "idMeeting",
    "date",
    "directory",
    "diary",
    "speaker",
    "country",
    "transcription",
    "audio",
    "editDownloadTranscript",
  ];

  technicalTeamDisplayedColumns = this.stbDisplayedColumns;

  get displayedColumns(): string[] {
    if (this.STB) {
      return this.filterTableColumns(this.stbDisplayedColumns);
    } else if (this.SEC) {
      return this.filterTableColumns(this.secDisplayedColumns);
    } else if (this.Directory) {
      return this.filterTableColumns(this.directoryDisplayedColumns);
    } else if (this.username === "technicalTeam") {
      return this.filterTableColumns(this.technicalTeamDisplayedColumns);
    } else {
      return this.filterTableColumns(this.stbDisplayedColumns);
    }
  }

  filterTableColumns(columns: string[]): string[] {
    return columns.filter((column: string) => {
      if (!this.showAdvancedFilters) {
        const acceptedColumns = [
          "idMeeting",
          "date",
          "directory",
          "transcription",
          "audio",
          "editDownloadTranscript",
          "download"
        ];
        return acceptedColumns.includes(column);
      } else {
        return column;
      }
    });
  }

  async ngOnInit() {
    console.log('ngOnInit')
    this.loadData();
    console.log('loadData')
    this.routeSubscription = this.route.params.subscribe(params => {
      console.log('route - loadData')
      this.loadData();
    });
  }
  
  async loadData() {
    await this.getUserRoles();

    // this.finding = true;
    this.username = localStorage.getItem("username");
    if (this.Directory) {
      this.showAdvancedFilters = true;
      this.isDirectory = true;
    }

    await this.getAllDataFilter().then(() => {});

    if (this.route.snapshot.queryParams['DAteAt'] ||
        this.route.snapshot.queryParams['DateTo'] ||
        this.route.snapshot.queryParams['Orator'] ||
        this.route.snapshot.queryParams['Diary'] ||
        this.route.snapshot.queryParams['Meeting'] ||
        this.route.snapshot.queryParams['Country'] ||
        this.route.snapshot.queryParams['Keyword'] ||
        this.route.snapshot.queryParams["advanced"]
    ) {
      var country = this.route.snapshot.queryParams["Country"];
      var start = this.route.snapshot.queryParams["DAteAt"];
      var end = this.route.snapshot.queryParams["DateTo"];
      var orator:any;
      if(Array.isArray(this.route.snapshot.queryParams["Orator"])){
         orator = this.route.snapshot.queryParams["Orator"];
      }
      else{
        if(this.route.snapshot.queryParams["Orator"] !== undefined){
        orator = new Array(this.route.snapshot.queryParams["Orator"]);
        }
      }
      var agenda = this.route.snapshot.queryParams["Diary"];
      var type: number = +this.route.snapshot.queryParams["Meeting"];
      var text = this.route.snapshot.queryParams["Keyword"];
      var search = this.route.snapshot.queryParams["advanced"]

      if (country != null && country !== undefined) {
        this.countryForm.setValue(country);
      }
      if (start != null && start !== undefined) {
        var fecha = new Date(start);
        this.startDate.setValue(fecha);
      }
      if (end != null && end !== undefined) {
        var fecha2 = new Date(end);
        this.endDate.setValue(fecha2);
      }
      if (orator && orator != null) {
        this.oratorForm.setValue(orator);
      }
      if (agenda != null && agenda !== undefined) {
        this.agendaForm.setValue(agenda);
      }
      if (type != null && type !== undefined && !isNaN(type)) {
        this.selectedMeeting = type;
      }
      if (text) {
        this.textForm.setValue(text);
      }
      if (search != null){
        this.showAdvancedFilters = (search == 'true') ? true : false;
      }

      await this.search().then(() => {
        this.finding = false;
      });
      if (this.selectedMeeting != null){
        this.serviceMeeting.getMeetingById(type).toPromise().then(
          (resp) => {
            this.typeForm.setValue(resp.data.topics);
        });
      }
    }
    
    this.oratorForm.valueChanges
    .pipe(
      startWith(''),
      filter((value)=> typeof value !== 'object'),
      map((value) => this._filter(value))
    ).subscribe((users) => {
      this.filterUserOptions = of(users);
    });
  }

  private _filter(search): userListModel[] {
    return this.usersList.filter(user => user.userName.toLowerCase().includes(search?.toLowerCase()) );
  }

  async getAllDataFilter() {
    /*LLenamos los arreglos de datos */
    await this.serviceMeeting.getMeetingName().toPromise().then(
      (resp) => {
        console.log({'getMeetingName': resp.listName})
        this.meetingList = resp.listName;
        console.log({'getMeetingName meetingList': this.meetingList})
        this.filterMeetingOptions = this.typeForm.valueChanges.pipe(
          startWith(""),
          filter((value) => this.isMeetingAvailableToAdd(value.topics)),
          map((value) => this.filteredMeeting(value))
        );
        console.log({'getMeetingName filterMeetingOptions': this.filterMeetingOptions})
      },
      (error) => {
        if(this.finding){
          this.finding = false;
          this.notificationModal(GlobalComponents.notSuccess);
        }
      }
    );

    await this.serviceSpeaker
      .getCountryName()
      .toPromise()
      .then(
        (resp) => {
          this.countryList = resp.countryList;
          this.filterCountryOptions = this.countryForm.valueChanges.pipe(
            startWith(""),
            map((value) => this.filteredCountry(value))
          );
        },
        (error) => {
          if (this.finding) {
            this.finding = false;
            this.notificationModal(GlobalComponents.notSuccess);
          }
        }
      );

    await this.serviceUsers
      .getUsers()
      .toPromise()
      .then(
        (resp) => {
          this.usersList = resp.user;
          this.filterUserOptions = this.oratorForm.valueChanges.pipe(
            startWith(""),
            map((value) => this.filter(value))
          );
        },
        (error) => {
          if (this.finding) {
            this.finding = false;
            this.notificationModal(GlobalComponents.notSuccess);
          }
        }
      );
  }

  filter(filter: any): userListModel[] {
    this.lastFilter = filter;
    if (filter) {
      return this.usersList.filter((option) => {
        return option.userName;
      });
    } else {
      return this.usersList.slice();
    }
  }

  optionClicked(event: Event, user: any) {
    event.stopPropagation();
    this.toggleSelection(user);
  }

  toggleSelection(user: any) {
    user.selected = !user.selected;

    if (user.selected) {
      this.selectedUsers.push(user.userName);
    } else {
      let index = this.selectedUsers.indexOf(user.userName);
      this.selectedUsers.splice(index, 1);
    }
    this.oratorForm.setValue(this.selectedUsers);
  }

  ngAfterViewInit() {
    console.log('ngAfterViewInit')
    if (!this.route.snapshot.queryParams["DAteAt"] &&
        !this.route.snapshot.queryParams["DateTo"] &&
        !this.route.snapshot.queryParams["Orator"] &&
        !this.route.snapshot.queryParams["Diary"] &&
        !this.route.snapshot.queryParams["Meeting"] &&
        !this.route.snapshot.queryParams["Country"] &&
        !this.route.snapshot.queryParams["Keyword"]
    ) {
      const meeting = [];
      this.serviceMeeting.getLatesMeetings().subscribe((resp) => {
          console.log('getLatesMeetings')
          resp.data.forEach((element) => {
            var varlidaBlock = false;
            if(element.editBy == null || element.editBy == ""){
              varlidaBlock = false;
            }else{
            if(element.editBy != this.username){
              varlidaBlock = true;
            }else{
              varlidaBlock = false;
            }
          }
            if( this.isMeetingAvailableToAdd(element.topics)){  
            meeting.push({
              idMeeting: element.meetingId,
              date: element.meetingDate,
              directory: element.topics,
              diary: element.agendaItemEn,
              idTranscription: 0,
              speaker: element.users,
              transcription: "Ver",
              audio: "audio",
              editDownloadTranscript: "Editar / PDF / Word",
              download: "PDF",
              btnDisabled: varlidaBlock,
              editBy: element.editBy,
              metadataId: element.metadataId,
              drEventId: element['drEventId'],
              drRecId: element['drRecId'],
              start: 0
            });
            }
          })
          this.dataSource = new MatTableDataSource<TablaItem>(meeting);

          this.changeDetectorRef.detectChanges();
          this.dataSource.paginator = this.paginator;
          this.obs = this.dataSource.connect();

          this.finding = false;
        },
        (error) => {
          if (this.finding) {
            this.finding = false;
            this.notificationModal(GlobalComponents.notSuccess);
          }
        }
      );
      this.dataSource = new MatTableDataSource<TablaItem>(meeting);
      this.dataSource.sort = this.sort;
      this.tableDataSource = this.dataSource.data;
      // this.finding = false;
      this.searchLoading = true;
      this.changeDetectorRef.detectChanges();
    }
  }

  handleDelete($event): void {
    const element = this.dataSource.data.find((row) => row.date === $event);
    if (element) {
      element.transcription;
    }
  }

  deselectOption() {
    this.countryForm.setValue(null);
  }

  resetOratorForm() {
    this.oratorForm.setValue(null);
    this.selectedUsers = [];
    const subscription = this.filterUserOptions.subscribe((users) => {
      users.forEach((user) => {
        user.selected = false;
      });
      
    });
    subscription.unsubscribe();
  }

  resetCountryForm() {
    this.countryForm.setValue(null);
    // this.selectedUsers = [];
    const subscription = this.filterCountryOptions.subscribe((users) => {
      // users.forEach((user) => {
      //   user.selected = false;
      // });
    });
    subscription.unsubscribe();
  }

  async search() {
    console.log('search')
    if (this.startDate.value != null ||
      this.endDate.value != null ||
      this.oratorForm.value != null ||
      this.agendaForm.value != null ||
      this.selectedMeeting != null ||
      this.countryForm.value != null ||
      this.textForm.value != null
    ) {
      if (this.startDate.value != null || this.endDate.value != null) {
        if (this.startDate.value == null || this.endDate.value == null) {
          return this.notificationModal('stt.search.selectDates');
        }
      }

      if (this.startDate.value > this.endDate.value) {
        return this.notificationModal('stt.search.difDate');
      }

      this.finding = true;
      this.ver = true;
      
      this.filters = {
        DAteAt: this.startDate.value,
        DateTo: this.endDate.value,
        Orator: this.oratorForm.value,
        Diary: this.agendaForm.value,
        Meeting: this.selectedMeeting,
        Country: this.countryForm.value,
        Keyword: this.textForm.value,
        pos1: 0,
        pos2: 5,
        advanced: this.showAdvancedFilters
      };

      const meeting = [];
      if (this.showAdvancedFilters == true) {
        await this.serviceTranscription
          .getTranscriptionByFilter(this.filters)
          .toPromise()
          .then((resp) => {
              if (resp.data.length == 0) {
                this.finding = false;
                this.notificationModal('stt.search.noResult');
              } else {
                console.log('getTranscriptionByFilter')
                resp.data.sort((a, b) => b.meeting.meetingId - a.meeting.meetingId);
                resp.data.forEach((element) => {
                  var varlidaBlock = false;
                  if(element.meeting.editBy == null || element.meeting.editBy == ""){
                    varlidaBlock = false;
                  }else{
                    if(element.meeting.editBy != this.username){
                      varlidaBlock = true;
                    }else{
                      varlidaBlock = false;
                    }
                  }
                  meeting.push({
                    idMeeting: element.meeting.meetingId,
                    date: element.meeting.datetime,
                    directory: element.meeting.topics,
                    diary: element.agendaItemEn,
                    idTranscription: element.transcriptionId,
                    speaker: element.users,
                    country: element.country,
                    transcription: "Ver",
                    audio: "audio",
                    editDownloadTranscript: "Editar / PDF / Word",
                    download: "PDF",
                    btnDisabled: varlidaBlock,
                    metadataId: element['metadataId'],
                    drEventId: element.meeting['drEventId'],
                    drRecId: element.meeting['drRecId'],
                    editBy: element.meeting.editBy,
                    start: element.start,
                    meeting: {
                      drEventId: element.meeting['drEventId'],
                      drRecId: element.meeting['drRecId']
                    }
                  });
                });
                this.dataSource = new MatTableDataSource<TablaItem>(meeting);
                this.changeDetectorRef.detectChanges();
                this.obs = this.dataSource.connect();
              }

              this.finding = false;

              this.router.navigate(["."], { queryParams: this.filters });
            },
            (error) => {
              if (this.finding) {
                this.finding = false;
                this.notificationModal(GlobalComponents.notSuccess);
              }
            });
      } else {
        await this.serviceMeeting
          .getMeetingByFilter(this.filters)
          .toPromise()
          .then((resp) => {

            if (resp.data.length == 0 && this.finding) {
              this.finding = false;
              this.notificationModal('stt.search.noResult');
            } else {
              console.log('getMeetingByFilter')
              resp.data.forEach((element) => {
                var varlidaBlock = false;
                if(element.editBy == null || element.editBy == ""){
                varlidaBlock = false;
                }else{
                  if(element.editBy != this.username){
                    varlidaBlock = true;
                  }else{
                    varlidaBlock = false;
                  }
                }
                if(this.isMeetingAvailableToAdd(element.topics)){
                meeting.push({
                  idMeeting: element.meetingId,
                  date: element.meetingDate,
                  directory: element.topics,
                  diary: element.agendaItemEn,
                  idTranscription: 0,
                  speaker: element.users,
                  transcription: "Ver",
                  audio: "audio",
                  editDownloadTranscript: "Editar / PDF / Word",
                  download: "PDF",
                  btnDisabled: varlidaBlock,
                  editBy: element.editBy,
                  metadataId: element.metadataId,
                  drEventId: element['drEventId'],
                  drRecId: element['drRecId'],
                  start: 0
                });
                }
              });
            }
            this.dataSource = new MatTableDataSource<TablaItem>(meeting);
            console.log({ 'getMeetingByFilter this.dataSource oUTSIDE': this.dataSource  })
            this.changeDetectorRef.detectChanges();
            this.obs = this.dataSource.connect();

            this.finding = false;

            this.router.navigate(["."], { queryParams: this.filters });
          }, (error) => {
            if(this.finding){
              this.finding = false;
              this.notificationModal(GlobalComponents.notSuccess);
            }
          });
      }
    } else {
      return this.notificationModal('stt.search.notOptions');
    }
    this.dataSource.sort = this.sort;
    setTimeout(() => this.dataSource.paginator = this.paginator);
    this.tableDataSource = this.dataSource.data;
    this.searchLoading = true;
  }

  async openModalMeeting(
    idMeeting,
    topicMeeting: string,
    dateMeeting: string,
    idTranscrip) {
    let speakerResponse = new Array<userListModel>();

    if (idTranscrip > 0) {
      await this.serviceSpeaker
        .getUserAdv(idTranscrip)
        .toPromise()
        .then(
          (r) => {
            speakerResponse = r.user;
          },
          (error) => {
            if (this.finding) {
              this.finding = false;
              this.notificationModal(GlobalComponents.notSuccess);
            }
          }
        );
    } else {
      await this.serviceSpeaker
        .getUserMeet(idMeeting)
        .toPromise()
        .then(
          (r) => {
            speakerResponse = r.user;
          },
          (error) => {
            if (this.finding) {
              this.finding = false;
              this.notificationModal(GlobalComponents.notSuccess);
            }
          }
        );
    }

    const us = [];
    speakerResponse.forEach((element) => {
      us.push({
        userId: element.userId,
        userName: element.userName,
        userEmail: element.userEmail,
      });
    });

    this.users = us;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "1000px";
    dialogConfig.maxHeight = "770px";
    dialogConfig.data = {
      colec: this.users,
      valor: idMeeting,
      topicMeeting: topicMeeting,
      dateMeeting: dateMeeting,
    };

    const modalRef = this.dialog.open(ModalMeetingComponent, dialogConfig);
  }

  isMeetingAvailableToAdd(topic : string){
    const isSteeringMeeting = this.SteeringCommittees.includes(topic)
    const isPresidentMeeting = this.PresidentCommittees.includes(topic)
    const isPresidentGroup = this.NoShowSteering
    console.log({isSteeringMeeting ,isPresidentMeeting,isPresidentGroup })
    if ( isSteeringMeeting || isPresidentMeeting ){
      if( isSteeringMeeting && isPresidentGroup){
        return false
      }
      if( isPresidentMeeting && !isPresidentGroup ){
        return false
      }
    }
    return true
  }

  async openModalAudio(data, language) {
    if(this.lastMeeting == data['idMeeting'] && this.lastLang == language) {
      return;
    }
    
    this.lastLang = language;
    this.lastMeeting = data['idMeeting'];

    if(this.showAdvancedFilters == true) {

      this.audioPlayerService.attach({ title: data.directory, startTime: '', endTime: '', link: '' })
  
      await this.serviceAudio.getAudioMeeting(data.meeting.drRecId, data.meeting.drEventId, language).then(audio => {
        this.audioPlayerService.attach({ title: data.directory, startTime: data.start, endTime: '', link: audio });
      })

    } else {
      
      this.audioPlayerService.attach({ title: data.directory, startTime: '', endTime: '', link: '' })
  
      await this.serviceAudio.getAudioMeeting(data.drRecId, data.drEventId, language).then(audio => {
        this.audioPlayerService.attach({ title: data.directory, startTime: '', endTime: '', link: audio });
      })
    }

  }

  DownloadPdf(meetingId: number) {
    let currentLanguage: Language = JSON.parse(localStorage.getItem('languaje'));
    var languageId: number;
    if( currentLanguage.code == "es"){
      languageId = 1;
    }
    else{
      languageId = 2;
    }

    this.serviceTranscription.getPdf(meetingId, languageId).toPromise()
    .then((response) => {      
      let tm = "";
      if(languageId == 1){
        tm = "_TranscripciónDeReunión_";
      }
      else{
        tm = "_MeetingTranscription_";
      }

      const blob = new Blob([response], { type: response.type });
      fileSaver.saveAs(blob, this.datepipe.transform(Date.now(), 'yyyyMMddHHmmss') + tm + meetingId + ".pdf")

      this.dialog.closeAll();
    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  DownloadWord(meetingId: number) {
    let currentLanguage: Language = JSON.parse(localStorage.getItem('languaje'));
    var languageId :number;
    if(currentLanguage.code == "es"){
      languageId = 1;
    }
    else{
      languageId = 2;
    }
    
    this.serviceTranscription.getWord(meetingId, languageId).toPromise()
    .then((response) => {

      let tm = "";
      if(languageId == 1){
        tm = "_TranscripciónDeReunión_";
      }
      else{
        tm = "_MeetingTranscription_";
      }

      const blob = new Blob([response], { type: response.type });
      fileSaver.saveAs(blob, this.datepipe.transform(Date.now(), 'yyyyMMddHHmmss') + tm + meetingId + ".docx")
        
      this.dialog.closeAll();
    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  notificationModal(message: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message: message,
      valor: 10,
    };
    const modalRef = this.dialog.open(ModalNotificationComponent, dialogConfig);
  }

  public filteredMeeting(value: string): MeetingModel[] {
    let filterValue = "";
    if(value != null){
      filterValue = value.toLowerCase();
    }
      return this.meetingList.filter((o) =>
      o.topics.toLowerCase().includes(filterValue)
      );
  }

  public filteredCountry(value: string): SpeakerCountry[] {

    let filterValue = "";
    if(value != null){
      filterValue = value.toLowerCase();

    }
      return this.countryList.filter((o) => {
        return  o.name?.toLowerCase()?.includes(filterValue)
      }
     
      );
  }

  async getUserRoles() {
    console.log('getUserRoles');
    let roles = await this.accessControlService.getRoles(); // Asegúrate de que esta función sea asincrónica.
  
    if (roles.length === 0) {
      // Usamos una Promise para esperar la suscripción
      await new Promise<void>((resolve) => {  // Especificamos el tipo <void>
        this.accessControlService.roles$.subscribe(role => {
          if (role.includes('AV:Access to all Board meeting recordings except Steering Committee')) {
            this.NoShowSteering = true;
            console.log({'subscribe this.NoShowSteering': this.NoShowSteering});
          }
          if (role.includes('SEC_Minutes_Officer') || role.includes('SEC_Minutes_Officers')) {
            this.STB = true;
          } else if (role.includes('Recording Searchers')) {
            this.SEC = true;
          } else if (role.includes('directory')) {
            this.Directory = true;
          }
  
          // Resolvemos la promesa al final de la lógica de suscripción
          resolve();  // Llamamos a resolve cuando hemos terminado
        });
      });
    } else {
      if (roles.includes('AV:Access to all Board meeting recordings except Steering Committee')) {
        this.NoShowSteering = true;
        console.log({'accessControlService this.NoShowSteering': this.NoShowSteering});
      }
      if (roles.includes('SEC_Minutes_Officer') || roles.includes('SEC_Minutes_Officers')) {
        this.STB = true;
      } else if (roles.includes('Recording Searchers')) {
        this.SEC = true;
      } else if (roles.includes('directory')) {
        this.Directory = true;
      }
    }
  }

  public SelectedMeeting(meetingId: number){
    this.selectedMeeting = meetingId;
  }
}